import { get } from '../../utils/http';

export const fetchAccountsCharts = ({ from, to }) => get(`/analytics/accountChart`, { from, to });

export const fetchAccountsCountries = ({ from, to }) => get(`/analytics/accountsCountries`, { from, to });

export const fetchAccountsIndustries = ({ from, to }) => get(`/analytics/accountsIndustries`, { from, to });

export const fetchAccountsStatuses = ({ from, to }) => get(`/analytics/accountsStatuses`, { from, to });

export const fetchAnalyticsActualVsScheduled = () => get(`/analytics/actualVsScheduledTimesheets`);

export const fetchAllPayrolls = () => get(`/analytics/allPayrolls`);

export const fetchAnalyticsBookedUnique = () => get(`/analytics/bookedUnique`);

export const fetchAnalyticsBookedUniqueByCountry = () => get(`/analytics/bookedUniqueByCountry`);

export const fetchAnalyticsBookedUniqueByCountryByCompany = (countryId) =>
  get(`/analytics/bookedUniqueByCountryByCompany`, { countryId: countryId || undefined });

export const fetchAnalyticsBookedVsNeeded = () => get(`/analytics/bookedVsNeeded`);

export const fetchAnalyticsFulfillment = () => get(`/analytics/fulfillment`);

export const fetchSmartAnalytics = ({ from, to }) => get(`/analytics/highlights`, { from, to });

export const fetchNewAccounts = ({ from, to }) => get(`/analytics/newAccounts`, { from, to });

export const fetchNewAdmins = ({ from, to }) => get(`/analytics/newAdmins`, { from, to });

export const fetchNewAppUsers = ({ from, to }) => get(`/analytics/newAppUsers`, { from, to });

export const fetchSmartReportsAnalytics = () => get(`/analytics/reports/highlights`);

export const fetchSchedulingOverview = ({ from, to }) => get(`/analytics/schedulingOverview`, { from, to });

export const fetchTimeclockOverview = ({ from, to }) => get(`/analytics/timeclockOverview`, { from, to });

export const fetchTotalTimesheetsHours = () => get(`/analytics/totalTimesheetsHours`);
